module.exports = __webpack_public_path__ + "img/bdxt.80d06f6d.png";